import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { Modal } from 'antd';

import style from 'style';
import QualifiedServiceIcon from 'components/QualifiedServiceIcon';
import { useHistory } from 'react-router-dom';
import * as track from 'lib/track';


const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  padding-bottom: 10px;
`;

const Service = styled.div`
  border: 1px solid ${style.colors.lightBorder};
  padding: 20px 20px;
  border-radius: ${style.borderRadius.medium};
  box-shadow: ${style.shadow(10)};
  display: flex;
  align-items: center;
  column-gap: 10px;
  cursor: pointer;
  font-weight: 500;
  :hover {
    border-color: ${style.colors.secondary};
  }
  .icon {
    font-size: 18px;
    color: ${style.colors.palette.darkSlateBlue};
  }
`;

const DirectConnectModal = ({ open, onCancel, serviceData }) => {
  const history = useHistory();

  const _serviceSet = new Set();
  const eligibleServices = serviceData?.filter(item => {
    if (_serviceSet.has(item.service) || !item.directConnectConfig.eligible) return false;
    _serviceSet.add(item.service);
    return true;
  });

  const handleClick = (uuid, providerUuid) => {
    track.sendEvent(track.CONNECT_ME_BUTTON_CLICK, track.EVENT_CLICK, {
      listing_uuid: uuid,
    }, [providerUuid]);
    history.push(`/requestmatch?service_offering=${uuid}`);
  };

  return (
    <Modal visible={open} onCancel={onCancel} title="What service are you looking for?" footer={null}>
      <Container>
        {eligibleServices?.map((item, idx) => (
          <Service key={idx} onClick={() => handleClick(item.uuid, item.providerUuid)}>
            <QualifiedServiceIcon.Regular serviceName={item.service} className="icon" />
            <div>{item.service}</div>
          </Service>
        ))}
      </Container>
    </Modal>
  );
};

DirectConnectModal.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func,
  serviceData: PropTypes.arrayOf(PropTypes.object),
};


export default DirectConnectModal;

